export class MissingSpotColorsError extends Error {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "message", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "Spot colors are missing"
    });
  }
}